import { Drawer } from 'vaul'

import { Button, type ButtonProps } from '~/components/button'
import type { TIconProps } from '~/components/icon'

import { cn } from '~/utils/cn'

type RightActionButton = ButtonProps & {
  icon?: TIconProps['symbol']
  hidden?: boolean
}

type SideSheetHeaderProps = {
  title: string
  description?: string
  iconBackButton?: TIconProps['symbol']
  showBackButton?: boolean
  onBackButton?(): void
  rightActionButton?: RightActionButton
}

function BottomSheetHeader({
  title,
  description,
  iconBackButton = 'rdicon-chevron-left',
  showBackButton = true,
  onBackButton,
  rightActionButton,
}: SideSheetHeaderProps) {
  return (
    <header
      className={cn(
        'mt-1.5 flex w-full items-center justify-between gap-2 px-[var(--padding-inset-fourpulse)] py-[var(--padding-inset-threepulse)]'
      )}
      data-slot="bottom-sheet-header"
    >
      <div className="inline-flex items-center gap-2 overflow-hidden">
        {showBackButton && (
          <Button.Root
            variant="neutral-tertiary"
            size="ml"
            onClick={onBackButton}
          >
            <Button.Icon symbol={iconBackButton} />
          </Button.Root>
        )}

        <hgroup
          className={cn(
            'max-w-full space-y-[var(--spacing-stack-onepulse)] *:line-clamp-2'
          )}
        >
          <Drawer.Title
            className={cn(
              'font-bold font-sans leading-7 tracking-normal',
              'text-[length:var(--font-size-fourpulse)] text-[var(--color-text-neutral-default)]'
            )}
          >
            {title}
          </Drawer.Title>

          <Drawer.Description
            className={cn(
              'font-normal font-sans leading-[140%]',
              'text-[length:var(--font-size-threeandhalfpulse)] text-[var(--color-text-neutral-alternative)]'
            )}
          >
            {description}
          </Drawer.Description>
        </hgroup>
      </div>

      {!rightActionButton?.hidden && (
        <Button.Root
          {...rightActionButton}
          className={cn('shrink-0')}
          variant="neutral-tertiary"
          size="ml"
        >
          <Button.Icon symbol={rightActionButton?.icon || 'rdicon-default'} />
        </Button.Root>
      )}
    </header>
  )
}

export { BottomSheetHeader }
